




































































































































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'eventDetailBox',
})
export default class extends Vue {
  @Prop()
  private eventItem: any;

  private eventDetail: any = {};
  private bigImages: boolean = false;
  private bigImgUrl: string = '';
  private images: boolean = true;
  private video: boolean = false;
  private elIndex: number = 1;
  private dialogTableVisible: boolean = false;

  private audioFrequency(index: number) {
    this.elIndex = index;
    if (index == 1) {
      this.images = true;
      this.video = false;
    } else {
      this.video = true;
      this.images = false;
    }
  }

  private closeImg() {
    this.bigImages = false;
  }
  private bigImg(url: string) {
    this.bigImages = true;
    this.bigImgUrl = url;
  }
}
